import React from "react";
import WidgetCard from "./WidgetCard";
import styles from "./WidgetEmpty.module.scss";

interface WidgetEmptyProps {
  /** same title/subtitle as the widget it stands in for */
  title?: string;
  subtitle?: string;
  message?: string;
  hint?: string;
}

/** Not-found placeholder shown inside a widget card when its API returns no data. */
export default function WidgetEmpty({
  title,
  subtitle,
  message = "No data found",
  hint = "There's nothing to show for this period yet.",
}: WidgetEmptyProps) {
  return (
    <WidgetCard title={title} subtitle={subtitle} stretch>
      <div className={styles.empty}>
        <svg
          width="42"
          height="42"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={styles.icon}
        >
          <path d="M3 7l9-4 9 4-9 4-9-4z" />
          <path d="M3 7v10l9 4 9-4V7" />
          <path d="M3 12l9 4 9-4" opacity="0.5" />
        </svg>
        <div className={styles.title}>{message}</div>
        <div className={styles.hint}>{hint}</div>
      </div>
    </WidgetCard>
  );
}
